// Copyright (c) 2021 Deere & Company

import MassLaborRateChange from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.claims.laborRateDealers,
    ...state.claims.massLaborRateChange
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;
    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(MassLaborRateChange);




// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/state-connector.js